<div class="core-engine-container">

  <ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>

  <div class="search-row align-center">
    <button class="btn dark-btn" (click)="createNew()">
      Create New Audio QR Code
    </button>
   <!-- <div class="input-with-icon align-row">
      <div class="input-icon align-center"><i class="flaticon-search"></i></div>
      <input
        type="text"
        placeholder="Search..."
        (keyup)="search()"
        [(ngModel)]="searchText"
        class="searchtext"
      />
    </div>-->
  </div>
  <div class="customTable">
    <div class="customTable-header">
      <div class="customTable-header-cell">
        CUE Name
      </div>
    </div>
    <div class="customTable-row" *ngFor="let object of displayObjects">
      <div class="customTable-content">
        <div class="customTable-content-cell">
          {{ object.name }}
        </div>
      </div>
      <div class="customTable-actions">
        <div class="customTable-actions-cell" (click)="download(object.coreEngineObjectId)">  
          Download
        </div>
        <div class="customTable-actions-cell" (click)="edit(object.coreEngineObjectId)">
          Edit
        </div>
        <div class="customTable-actions-cell" (click)="delete(object)">
          Delete
        </div>
      </div>
    </div>
    <div *ngIf="!displayObjects || displayObjects === undefined || displayObjects.length === 0"> No Audio QR Codes to show, click 'Create New Audio QR Code' to begin </div>
  </div>
</div>
